import { render, staticRenderFns } from "./DashboardAlert.vue?vue&type=template&id=395033a9&"
import script from "./DashboardAlert.vue?vue&type=script&lang=js&"
export * from "./DashboardAlert.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAlert.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports